(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-guides"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lglgfg-size-guide')) {
    customElements.define('lglgfg-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger = this.querySelector('.lglgfg-size-guides__trigger');
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('.lglgfg-size-guides__close');
        if (!this.trigger || !this.dialog) return;
        this.trigger.addEventListener('click', () => {
          this.previousOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        const outside = event => {
          const rect = this.dialog.getBoundingClientRect();
          return event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        };
        this.dialog.addEventListener('pointerdown', event => { this.backdropDown = outside(event); }, options);
        this.dialog.addEventListener('click', event => {
          if (this.backdropDown && outside(event)) this.dialog.close();
          this.backdropDown = false;
        }, options);
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
          document.body.style.overflow = this.previousOverflow || '';
        }
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
